/**
 * SignatureEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { PersonEntity } from "../PersonEntity";
import { SignOffEntity } from "../SignOffEntity";
import { SignatureEntity } from "../SignatureEntity";
declare global {
    interface EntityTypeMap {
        Signature: SignatureEntity;
    }
}
export abstract class SignatureGeneratedEntity extends BaseEntity {
    public abstract signatureId: string;
    public abstract creationDate: Date;
    public abstract context: string | null;
    public abstract contact: PersonEntity;
    public abstract companySignOff: SignOffEntity | null;
    public abstract occupantSignOff: SignOffEntity | null;
}
